module.exports = __webpack_public_path__ + "static/media/canais-6.ca7515f3.jpg";